
/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import {throwError as observableThrowError,  Observable } from 'rxjs';
import { BaseApi } from './BaseApi';

export class ReportingFrameworkApi extends BaseApi {
  endPoint: string = '/api/admin/reporting-frameworks';

  public import(body): Observable<any> {
    return this.post(`${this.endPoint}/import`, {}, body);
  }

}
